import { render, staticRenderFns } from "./ConfigureChartSelection.vue?vue&type=template&id=28391b66&"
import script from "./ConfigureChartSelection.vue?vue&type=script&lang=js&"
export * from "./ConfigureChartSelection.vue?vue&type=script&lang=js&"
import style0 from "./ConfigureChartSelection.vue?vue&type=style&index=0&id=28391b66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports